module.exports = __webpack_public_path__ + "img/distraida.d000ef41.png";